/**
 * Minimal classnames helper — joins truthy class arguments with spaces.
 * Avoids pulling `clsx` + `tailwind-merge` until we actually need
 * class-conflict resolution (currently: we don't).
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
